const settingApiKeysEn = {
  settings_api_keys_api_docs: "More Info - API",
  settings_apikeys_create_dialog_title: "Create New API Key",
  settings_apikeys_create_dialog_desc:
    "Create a new API key to enable external systems to access your account.",
  settings_apikeys_edit_dialog_title: "Edit API Key",
  settings_apikeys_edit_dialog_desc:
    "Update this key's name, description, and credit limit.",
  settings_api_keys_credit_limit: "Credit limit",
  settings_api_keys_credit_limit_desc:
    "Cap how many credits this key can spend.",
  settings_api_keys_credit_period_monthly: "Monthly",
  settings_api_keys_credit_period_lifetime: "Lifetime",
  settings_api_keys_credit_hint_monthly:
    "Resets to zero at the start of each month.",
  settings_api_keys_credit_hint_lifetime:
    "A fixed budget for the lifetime of this key.",
  settings_api_keys_credit_unlimited: "No Limit",
  settings_api_keys_credit_unit: "credits",
  settings_api_keys_credit_per_month_short: "/mo",
  settings_api_keys_credit_lifetime_short: "total",
  settings_api_keys_scope: "Scope",
  settings_api_keys_scope_title: "Endpoint access",
  settings_api_keys_scope_desc: "Limit which endpoints this key can call.",
  settings_api_keys_scope_hint:
    "Unselected endpoints are rejected. Reference lookups (locations, technologies…) stay available.",
  settings_api_keys_scope_empty_warning:
    "Select at least one endpoint, or turn off restrictions for full access.",
  settings_api_keys_scope_full_access: "Full access",
  settings_api_keys_scope_selected: "selected",
  settings_api_keys_scope_select_all: "Select all",
  settings_api_keys_scope_clear: "Clear",
  edit: "Edit",
  Save: "Save",
  settings_apikeys_form_name_placeholder: "Enter a name for the API key",
  settings_apikeys_form_description_placeholder:
    "Enter a short description of the key's purpose",
  settings_apikeys_form_services_placeholder:
    "Select a service to associate with this key",
  settings_api_keys_api_tip:
    "If you don't select any APIs for this new key, we will assume that this new API key is a 'master' key",
  settings_api_keys_api_set_master_key: "Set as master key",
  "API Keys": "API Keys",
  API_Service: "API Service",

  usage_total_this_month: "Total calls this month:",
  usage_remaining_quota: "Remaining quota:",
  usage_reset_on: "Reset on:",
  call: "call | call | calls",
  _usage_sub_title: " usage",
  portal_usage_sub_title: " Query Limit",
  hourly: "hourly",
  daily: "daily",
  monthly: "monthly",
  usage_portal_title: "Portal Limit",
  usage_api_title: "API",
  settings_apikeys_name: "API Key Name",

  api_keys_column_query_type: "Query Type",
  api_keys_column_auth_type: "Auth Type",
  api_keys_column_credential: "Credential",
  settings_api_logs_column_method: "Method",
  settings_api_logs_column_endpoint: "Endpoint",
  settings_api_logs_column_status: "Status",
  settings_api_logs_column_duration: "Duration",
  settings_api_logs_detail_request: "Request",
  settings_api_logs_detail_response: "Response",
  settings_api_logs_detail_request_id: "Request ID",
  settings_api_keys_click_here_more_info: "Click here for more info",
  settings_api_keys_title: "API Keys",
  settings_api_keys_desc:
    "The API Key Settings page enables secure creation, editing, and restriction of API keys. Users can assign names, set usage limits, and manage permissions to control access effectively.",
  settings_api_keys_generated_by: "Generated By",
  api_key: "API Key",
  logs: "Logs",
  new_api_key: "New API Key",
  dashboard: "Dashboard",
  settings_api_dashboard_empty_title: "No API activity yet",
  settings_api_dashboard_empty_desc:
    "Once your integration starts making calls, this dashboard will show your daily credit consumption, request counts, and breakdowns by key and endpoint.",
  settings_api_dashboard_empty_cta: "View Quickstart",
  settings_api_dashboard_chart_title: "Daily Usage",
  settings_api_dashboard_chart_metric_credits: "Credits",
  settings_api_dashboard_chart_metric_calls: "Calls",
  settings_api_dashboard_chart_no_data: "No usage in this range",
  settings_api_dashboard_chart_others: "Others",
  settings_api_dashboard_chart_last_refreshed: "Last refreshed {time}",
  settings_api_dashboard_kpi_total_credits: "Total Credits",
  settings_api_dashboard_kpi_credits_pending: "pending backend",
  settings_api_dashboard_kpi_total_calls: "Total Calls",
  settings_api_dashboard_kpi_avg_per_day: "Avg / Day",
  settings_api_dashboard_kpi_avg_per_day_short: "day",
  settings_api_dashboard_kpi_range_days: "Last {days} days",
  settings_api_dashboard_kpi_top_endpoint: "Top Endpoint",
  settings_api_dashboard_kpi_top_key: "Top API Key",
  settings_api_dashboard_filter_date_label: "Date range",
  settings_api_dashboard_filter_keys_label: "API key",
  settings_api_dashboard_filter_keys_placeholder: "All API keys",
  settings_api_dashboard_filter_log_types_label: "Log type",
  settings_api_dashboard_filter_log_types_placeholder: "All log types",
  settings_api_dashboard_preset_7d: "Last 7 days",
  settings_api_dashboard_preset_30d: "Last 30 days",
  settings_api_dashboard_preset_90d: "Last 90 days",
  settings_api_dashboard_preset_custom: "Custom",
  settings_api_dashboard_table_by_key: "By API Key",
  settings_api_dashboard_table_by_endpoint: "By Query Type",
  settings_api_dashboard_table_col_name: "Name",
  settings_api_dashboard_table_col_endpoint: "Query Type",
  settings_api_dashboard_table_col_calls: "Calls",
  settings_api_dashboard_table_col_credits: "Credits",
  settings_api_dashboard_table_col_cost_per_call: "Cost / call",
  settings_api_dashboard_table_col_percent: "% of total",
  settings_api_dashboard_table_empty: "No calls in this range",
  settings_api_dashboard_truncated_banner:
    "Showing the most recent 5,000 requests in this range. Narrow the date range for the full picture.",
  settings_api_dashboard_provisional_note:
    "Backend dashboard endpoints not deployed yet — showing call counts aggregated from /api_keys/logs. Credit cost lands when /api_keys/usage/daily is live.",

  // Log type display labels. Keys mirror backend LOG_TYPE slugs so the helper
  // (utils/logTypeLabel.js) can look them up by `log_type_label_${slug}`.
  log_type_label_people_search: "People Search",
  log_type_label_people_select_search: "People Select Search",
  log_type_label_people_search_preview: "People Search Preview",
  log_type_label_people_similar_search: "People Similar Search",
  log_type_label_people_similar_search_preview: "People Similar Search Preview",
  log_type_label_people_details: "People Details",
  log_type_label_people_redeem: "Redeem People",
  log_type_label_people_email_redeem: "Redeem Email",
  log_type_label_people_phone_redeem: "Redeem Phone",
  log_type_label_people_lookup_reveal: "People Lookup Reveal",
  log_type_label_people_contact_lookup: "People Contact Lookup",
  log_type_label_people_enrichment: "People Enrichment",
  log_type_label_people_export: "People Export",
  log_type_label_people_linkedin_lookup: "People LinkedIn Lookup",
  log_type_label_email_validation: "Email Validation",
  log_type_label_company_search: "Company Search",
  log_type_label_company_select_search: "Company Select Search",
  log_type_label_company_search_preview: "Company Search Preview",
  log_type_label_company_similar_search: "Company Similar Search",
  log_type_label_company_similar_search_preview:
    "Company Similar Search Preview",
  log_type_label_company_trending_search: "Company Trending Search",
  log_type_label_company_details: "Company Details",
  log_type_label_company_news: "Company News",
  log_type_label_company_jobs: "Company Jobs",
  log_type_label_company_enrichment: "Company Enrichment",
  log_type_label_company_export: "Company Export",
  log_type_label_company_linkedin_lookup: "Company LinkedIn Lookup",
  log_type_label_company_technology_lookup: "Company Technology Lookup",
  log_type_label_company_lookup_similar: "Company Lookup Similar",
  log_type_label_news_search: "News Search",
  log_type_label_news_search_preview: "News Search Preview",
  log_type_label_job_search: "Job Search",
  log_type_label_job_search_preview: "Job Search Preview",
  log_type_label_advertisement_lookup: "Advertisement Lookup",
  log_type_label_advertisement_search: "Advertisement Search",
  log_type_label_advertisement_search_preview: "Advertisement Search Preview",
  log_type_label_ai_translation: "AI Translation",
  log_type_label_monitor_trigger: "Monitor Trigger",
  log_type_label_general: "General",

  // API dashboard health + Logs filters.
  settings_api_dashboard_outcome_succeeded: "Succeeded",
  settings_api_dashboard_outcome_client_errors: "Client errors (4xx)",
  settings_api_dashboard_outcome_server_errors: "Server errors (5xx)",
  settings_api_dashboard_kpi_requests: "Requests",
  settings_api_dashboard_kpi_success_rate: "Success rate",
  settings_api_dashboard_kpi_failed_count: "{count} failed",
  settings_api_dashboard_kpi_no_failures: "No failed calls",
  settings_api_dashboard_kpi_redeem_match_rate: "Redeem match rate",
  settings_api_dashboard_kpi_lookup_match_rate: "Lookup match rate",
  settings_api_dashboard_kpi_match_none_yet: "No redeems or lookups yet",
  settings_api_dashboard_kpi_match_contacts: "{matched} of {asked} contacts found",
  settings_api_dashboard_kpi_match_records: "{matched} of {asked} records found",
  settings_api_dashboard_kpi_match_found: "{matched} of {asked} found",
  settings_api_dashboard_view_in_logs: "View all in Logs",
  settings_api_dashboard_view_misses_in_logs: "View misses in Logs",
  settings_api_dashboard_kpi_latency: "Median latency",
  settings_api_dashboard_kpi_latency_p95: "p95 {time}",
  settings_api_dashboard_kpi_credits_used: "Credits used",
  settings_api_dashboard_kpi_per_day: "{count} / day",
  settings_api_dashboard_match_found: "Found",
  settings_api_dashboard_match_none: "No match",
  settings_api_dashboard_match_title: "Match rate",
  settings_api_dashboard_match_caption: "Successful calls that found data. Click a row to see the misses.",
  settings_api_dashboard_match_empty: "No redeems or lookups in this range.",
  settings_api_dashboard_match_row_hint: "See the calls that found nothing",
  settings_api_dashboard_match_group_contacts: "Contacts",
  settings_api_dashboard_match_group_records: "Records",
  settings_api_dashboard_errors_title: "Errors",
  settings_api_dashboard_errors_caption: "Most frequent failures. Click one to see its calls.",
  settings_api_dashboard_errors_empty: "No failed calls in this range.",
  settings_api_dashboard_errors_row_hint: "See these calls in Logs",
  settings_api_dashboard_errors_no_message: "No error message",
  settings_api_dashboard_errors_code: "code {code}",
  settings_api_dashboard_errors_last_seen: "last {time}",
  settings_api_dashboard_endpoints_title: "Endpoints",
  settings_api_dashboard_endpoints_caption: "Volume, reliability and speed per endpoint. Click a row to see its calls.",
  settings_api_dashboard_endpoints_col_endpoint: "Endpoint",
  settings_api_dashboard_endpoints_col_success: "Success",
  settings_api_dashboard_endpoints_col_median: "Median",
  settings_api_dashboard_endpoints_col_match: "Match",
  settings_api_dashboard_endpoints_row_hint: "See this endpoint's calls",
  settings_api_dashboard_chart_metric_status: "Status",
  settings_api_logs_column_result: "Result",
  settings_api_logs_result_found: "Found",
  settings_api_logs_result_no_match: "No match",
  settings_api_logs_status_all: "All",
  settings_api_logs_status_succeeded: "Succeeded",
  settings_api_logs_status_failed: "Failed",
  settings_api_logs_filter_endpoint_placeholder: "All endpoints",
  settings_api_logs_filter_code: "Error code {code}",
  settings_api_logs_filter_keys: "Key: {keys}",
  settings_api_logs_filter_remove: "Remove {name}",
  settings_api_logs_filter_clear: "Clear filters",
  settings_api_logs_sort_newest: "Newest first",
  settings_api_logs_sort_oldest: "Oldest first",
};

export default settingApiKeysEn;
